module.exports = __webpack_public_path__ + "static/media/CircularStd-Bold.05e42684.eot";